module.exports = __webpack_public_path__ + "static/media/facebook.8be7ab9c.svg";